/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

const types = {
  routeTypes: {
    departure: 1,
    active: 2,
    all: 3,
  },
  regions: [
    { title: "Air", id: 22 },
    { title: "Canada", id: 12 },
    { title: "Corporate Transportation", id: 10 },
    { title: "East", id: 7 },
    { title: "UPS Freight", id: 27 },
    { title: "West", id: 3 },
  ],
  districts: [
    { title: "CACH", id: 17 },
    { title: "Canada", id: 97 },
    { title: "Central Plains", id: 55 },
    { title: "Chesapeake", id: 33 },
    { title: "Desert Mountain", id: 95 },
    { title: "Florida", id: 40 },
    { title: "Great Lakes", id: 64 },
    { title: "Louisville Air", id: 65 },
    { title: "Mid Atlantic", id: 32 },
    { title: "Mid-South", id: 44 },
    { title: "North Atlantic", id: 20 },
    { title: "North California", id: 86 },
    { title: "Northeast", id: 36 },
    { title: "Northern Plains", id: 56 },
    { title: "Northwest", id: 76 },
    { title: "Ohio Valley", id: 49 },
    { title: "Red River", id: 12 },
    { title: "SMART", id: 15 },
    { title: "South Atlantic", id: 45 },
    { title: "South California", id: 92 },
    { title: "UPS Freight", id: 8 },
  ],
  requestStatuses: {
    initial: "initial",
    inProgress: "in progress",
    success: "success",
    failure: "failure",
  },
  legStatuses: {
    ready: 1,
    active: 2,
    complete: 3,
    cancelled: 4,
    orphaned: 5,
  },
  legStatusesDescriptions: {
    0: "Unknown",
    1: "Ready",
    2: "Active",
    3: "Completed",
    5: "Orphaned",
  },
  sortTypes: {
    Day: { description: "Day (D)", code: "D", value: 1 },
    Twilight: { description: "Twilight (T)", code: "T", value: 2 },
    Night: { description: "Night (N)", code: "N", value: 3 },
    Preload: { description: "Preload (P)", code: "P", value: 4 },
    Empty: { description: "Empty (E)", code: "E", value: 5 },
    AfternoonOrAirRecovery: {
      description: "Afternoon or Air Recovery (A)",
      code: "A",
      value: 6,
    },
    CustomerPickUp: {
      description: "Customer Pick-Up (C)",
      code: "C",
      value: 7,
    },
    LocalSort: { description: "Local (L)", code: "L", value: 8 },
    MorningOrMidnight: {
      description: "Morning or Midnight (M)",
      code: "M",
      value: 9,
    },
    Sunrise: { description: "Sunrise (S)", code: "S", value: 10 },
    ThreeDSOntarioOnlyNightSort: {
      description: "3DS Ontario Only Night Sort (Q)",
      code: "Q",
      value: 11,
    },
    LateSunriseSort: { description: "Late Sunrise (V)", code: "V", value: 12 },
    AircraftParts: { description: "Aircraft parts (X)", code: "X", value: 13 },
  },
  serviceLevels: [
    { code: "G", description: "Ground", id: 1 },
    { code: "N", description: "Next Day Air", id: 2 },
    { code: "S", description: "Second Day Air", id: 3 },
    { code: "3", description: "Three Day Select", id: 4 },
    { code: "E", description: "Empty", id: 5 },
    { code: "I", description: "International", id: 6 },
    { code: "U", description: "ULD Movement", id: 7 },
    { code: "A", description: "COMAT", id: 8 },
    { code: "W", description: "WEPS", id: 9 },
  ],
  goTrackUserRoles: {
    unknown: 0,
    administrator: 1,
    carrier: 2,
    shipper: 3,
    shipperManager: 4,
  },
  goTrackUserRolesDescription: {
    0: "Unknown",
    1: "Administrator",
    2: "Carrier",
    3: "Shipper",
    4: "Shipper Manager",
  },
  spotTrailerTypes: [
    { title: "", id: 0 },
    { title: "Short", id: 1 },
    { title: "Long", id: 2 },
  ],
  spotDriverTypes: [
    { title: "Unknown", id: 0 },
    { title: "Single", id: 1 },
    { title: "Team", id: 2 },
  ],
  spotRequirements: [
    { title: "UIIA", id: 1 },
    { title: "Doubles", id: 2 },
  ],
  spotLegStatusEnum: {
    unknown: 0,
    uncovered: 1,
    coveredBrown: 2,
    coveredAssignedCarrier: 3,
    posted: 4,
    cancelled: 5,
    claimed: 6,
  },
  spotLegStatusDescriptions: {
    0: "Unknown",
    1: "Uncovered",
    2: "Covered",
    3: "Covered",
    4: "Posted",
    5: "Cancelled",
    6: "Claimed",
  },
  spotLegStatusWithCreationType: [
    { title: "All", id: 2, status: 0 },
    { title: "Cancelled", id: 8, status: 5 },
    { title: "Claimed", id: 9, status: 6 },
    { title: "Covered - Assigned Carrier", id: 7, status: 3 },
    { title: "Covered - Brown", id: 6, status: 2 },
    { title: "Posted", id: 5, status: 4 },
    { title: "Uncovered - EPTS", id: 3, status: 1, creationType: 2 },
    {
      title: "Uncovered - Manual Ad Hoc",
      id: 4,
      status: 1,
      creationType: 1,
    },
    { title: "Uncovered + Posted + Claimed", id: 1, status: 1 },
  ],
  carrierSpotLegStatusWithCreationType: [
    { title: "Claimed", id: 9, status: 6 },
    { title: "Posted", id: 1, status: 4 },
  ],
  spotLegStatus: {
    uncovered: "Uncovered",
    coveredBrown: "Covered - Brown",
    coveredAssignedCarrier: "Covered - Assigned Carrier",
    posted: "Posted",
    cancelled: "Cancelled",
    claimed: "Claimed",
  },
  states: [
    { title: "Alabama", id: "AL" },
    { title: "Alaska", id: "AK" },
    { title: "Arizona", id: "AZ" },
    { title: "Arkansas", id: "AR" },
    { title: "California", id: "CA" },
    { title: "Colorado", id: "CO" },
    { title: "Connecticut", id: "CT" },
    { title: "Delaware", id: "DE" },
    { title: "District of Columbia", id: "DC" },
    { title: "Florida", id: "FL" },
    { title: "Georgia", id: "GA" },
    { title: "Hawaii", id: "HI" },
    { title: "Idaho", id: "ID" },
    { title: "Illinois", id: "IL" },
    { title: "Indiana", id: "IN" },
    { title: "Iowa", id: "IA" },
    { title: "Kansas", id: "KS" },
    { title: "Kentucky", id: "KY" },
    { title: "Louisiana", id: "LA" },
    { title: "Maine", id: "ME" },
    { title: "Maryland", id: "MD" },
    { title: "Massachusetts", id: "MA" },
    { title: "Michigan", id: "MI" },
    { title: "Minnesota", id: "MN" },
    { title: "Mississippi", id: "MS" },
    { title: "Missouri", id: "MO" },
    { title: "Montana", id: "MT" },
    { title: "Nebraska", id: "NE" },
    { title: "Nevada", id: "NV" },
    { title: "New Hampshire", id: "NH" },
    { title: "New Jersey", id: "NJ" },
    { title: "New Mexico", id: "NM" },
    { title: "New York", id: "NY" },
    { title: "North Carolina", id: "NC" },
    { title: "North Dakota", id: "ND" },
    { title: "Ohio", id: "OH" },
    { title: "Oklahoma", id: "OK" },
    { title: "Oregon", id: "OR" },
    { title: "Pennsylvania", id: "PA" },
    { title: "Rhode Island", id: "RI" },
    { title: "South Carolina", id: "SC" },
    { title: "South Dakota", id: "SD" },
    { title: "Tennessee", id: "TN" },
    { title: "Texas", id: "TX" },
    { title: "Utah", id: "UT" },
    { title: "Vermont", id: "VT" },
    { title: "Virginia", id: "VA" },
    { title: "Washington", id: "WA" },
    { title: "West Virginia", id: "WV" },
    { title: "Wisconsin", id: "WI" },
    { title: "Wyoming", id: "WY" },
  ],
  legUpdateTypes: {
    unknown: 0,
    checkCall: 1,
    arrival: 2,
    departure: 3,
    miscellaneousNote: 4,
  },
  legMoveTypes: {
    trailer: 0,
    doubleTrailer: 1,
    bobTail: 2,
  },
  spotSortTypes: {
    unknown: 0,
    default: 1,
    note: 2,
    spotLegsId: 3,
    creationType: 4,
    window: 5,
    status: 6,
    routeCode: 7,
    movementOrigin: 8,
    scheduledDeparture: 9,
    movementDestination: 10,
    originCity: 11,
    originState: 12,
    destinationCity: 13,
    destinationState: 14,
    distance: 15,
    serviceLevel: 16,
    trailer: 17,
    trailerType: 18,
    driverType: 19,
    requirements: 20,
    assignedUser: 21,
    loadOrigin: 22,
    loadDestination: 23,
    scheduledArrival: 24,
    upsRouteId: 25,
  },
  spotSortDirection: {
    unknown: 0,
    ascending: 1,
    descending: 2,
  },
  alerts: {
    pastPlannedDeparture: {
      description: "Past Planned Departure",
      value: 1,
    },
    silentOverThreeHours: {
      description: "Silent Over Three Hours",
      value: 2,
    },
    atRiskOfLateArrival: {
      description: "At Risk of Late Arrival",
      value: 3,
    },
    atRiskOfMissingSortCutoff: {
      description: "At Risk of Missing Sort Cutoff",
      value: 4,
    },
    estimatedToDepartNextLegLate: {
      description: "Estimated To Depart Next Leg Late",
      value: 5,
    },
    possibleImpact: {
      value: 6,
      description: "Possible Impact",
    },
    shutdown: {
      value: 7,
      description: "Shutdown Reported",
    },
  },
  problemCodes: [
    { id: 1, description: "No" },
    { id: 2, description: "Breakdown on UPS Equipment", code: "EQ" },
    { id: 3, description: "Carrier Performance", code: "CP" },
    { id: 5, description: "Hours of Service", code: "HS" },
    { id: 7, description: "Weather", code: "WX" },
    { id: 9, description: "Tractor Breakdown on Property", code: "BP" },
    { id: 10, description: "Tractor Breakdown on Road", code: "BR" },
    { id: 11, description: "Late Sort", code: "LS" },
    { id: 13, description: "Scales - Port of Entry", code: "DS" },
    { id: 14, description: "Driver Performance", code: "DP" },
    { id: 15, description: "Traffic: Accident, Const, Heavy", code: "TR" },
    { id: 16, description: "Team Had Accident", code: "AC" },
    { id: 17, description: "Team Swapped into Sub", code: "SU" },
    { id: 22, description: "Late Dispatch Caused Delay", code: "LD" },
    { id: 24, description: "Loads Late Arriving Meet Point", code: "MP" },
    { id: 25, description: "Team Swapped Back into Tractor", code: "SB" },
    { id: 26, description: "Driver Sick", code: "SK" },
    { id: 34, description: "Late Train", code: "LT" },
  ],
  notifications: {
    legUpdated: "Leg updated.",
    legUnavailable: "This leg is no longer available.",
    legClaimed: "You have claimed the posted leg.",
    routeClaimed: "Route claimed.",
    routeUpdated: "Route updated.",
    claimRejected: "Claim rejected and leg posted.",
  },
  tiers: {
    tier1: 1,
    tier2: 2,
    tier3: 3,
    doNotUse: 4,
  },
  featureFlags: {},
  appRoutes: {
    tracking: "tracking",
    availableroutes: "availableroutes",
    userManagement: "user-management",
    carrierManagement: "carrier-management",
  },
  carrierTiers: [
    { id: 1, title: "All tiers" },
    { id: 2, title: "Tier 1" },
    { id: 3, title: "Tier 2" },
    { id: 4, title: "Tier 3" },
    { id: 5, title: "Do Not Use" },
  ],
  rejectionReasons: {
    unknown: 0,
    legCovered: 1,
    legCancelled: 2,
    proposedDateTime: 3,
    other: 4,
  },
  rejectionReasonDescriptions: {
    legCovered: "Leg Covered",
    legCancelled: "Leg Cancelled",
    proposedDateTime: "Proposed Date/Time",
    other: "Other",
  },
  claimStatus: {
    submitted: 1,
    accepted: 2,
    rejected: 3,
    cancelled: 4,
  },
  noteReadStatus: {
    unknown: 0,
    none: 1,
    unread: 2,
    read: 3
  }
};

export default types;
